import { each, isNil } from '@antv/util';
// æ±ä»¥aä¸ºæ¬¡å¹ï¼ç»æä¸ºbçåºæ°ï¼å¦ x^^a = b;æ±x
// è½ç¶æ°å­¦ä¸ b ä¸æ¯æè´æ°ï¼ä½æ¯è¿ééè¦æ¯æ è´æ°
export function calBase(a, b) {
    var e = Math.E;
    var value;
    if (b >= 0) {
        value = Math.pow(e, Math.log(b) / a); // ä½¿ç¨æ¢åºå¬å¼æ±åº
    }
    else {
        value = Math.pow(e, Math.log(-b) / a) * -1; // ä½¿ç¨æ¢åºå¬å¼æ±åº
    }
    return value;
}
export function log(a, b) {
    if (a === 1) {
        return 1;
    }
    return Math.log(b) / Math.log(a);
}
export function getLogPositiveMin(values, base, max) {
    if (isNil(max)) {
        max = Math.max.apply(null, values);
    }
    var positiveMin = max;
    each(values, function (value) {
        if (value > 0 && value < positiveMin) {
            positiveMin = value;
        }
    });
    if (positiveMin === max) {
        positiveMin = max / base;
    }
    if (positiveMin > 1) {
        positiveMin = 1;
    }
    return positiveMin;
}
function digitLength(num) {
    // Get digit length of e
    var eSplit = num.toString().split(/[eE]/);
    var len = (eSplit[0].split('.')[1] || '').length - +(eSplit[1] || 0);
    return len > 0 ? len : 0;
}
/**
 * é«ç²¾åº¦å æ³ï¼è§£å³ 0.1 + 0.2 !== 0.3 çç»å¸é®é¢
 *
 * @param num1 å æ°
 * @param num2 è¢«å æ°
 * @return {number} è¿åå¼
 */
export function precisionAdd(num1, num2) {
    var num1Digits = digitLength(num1);
    var num2Digits = digitLength(num2);
    var baseNum = Math.pow(10, Math.max(num1Digits, num2Digits));
    return (num1 * baseNum + num2 * baseNum) / baseNum;
}
//# sourceMappingURL=math.js.map